import { makeCommandFromAttributes } from '../../utils/index.js';
export var Track;
(function (Track) {
    Track["MAIN"] = "MAIN";
    Track["PROG"] = "PROG";
    Track["JOIN"] = "JOIN";
})(Track || (Track = {}));
/**
 * https://dcc-ex.com/reference/software/command-reference.html#track-power-commands
 */
export const powerCommand = ({ power, track }) => {
    const attributes = [
        power,
        track
    ];
    return makeCommandFromAttributes(attributes);
};
